import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllModels = async () => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/quotations/models/all`);
  const result = await response.json();
  return result;
};

export default fetchAllModels;
